import { z } from 'zod'
import { NotificationType } from '../../enums'

export const telegramPreferenceSchema = z.object({
  notificationType: z.nativeEnum(NotificationType),
  enabled: z.boolean(),
})

export const telegramPreferencesResponseSchema = z.array(telegramPreferenceSchema)

export type TelegramPreferenceDto = z.infer<typeof telegramPreferenceSchema>
export type TelegramPreferencesResponseDto = z.infer<typeof telegramPreferencesResponseSchema>
